import { TrustpilotExtended } from "modules/sections/AboveTheFold/Trustpilot";
import type { TrustpilotExtendedProps } from "modules/sections/AboveTheFold/Trustpilot";
import type { ReactStoryblokComponent } from "types/storyblok";

const TrustpilotExtendedAdapter = ({
  blok: { trustpilotVariant },
}: ReactStoryblokComponent<TrustpilotExtendedProps>) => <TrustpilotExtended trustpilotVariant={trustpilotVariant} />;

export default TrustpilotExtendedAdapter;
